import {Component, ViewChild} from '@angular/core';
import {MatTabGroup} from '@angular/material';

@Component({
  templateUrl: './evaluation.component.html'
})
export class EvaluationComponent {
  @ViewChild('tab', {static: false}) matTab: MatTabGroup;

  constructor() {
  }
}
